import {
    createNotification,
    Notification,
} from '@vfde-brix/ws10/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    ERROR_NOTIFICATION_CONTAINER_ID,
    ERROR_NOTIFICATION_ROOT_CONTAINER,
} from 'Container/App/constants';
import { startAppListening } from 'Container/App/listener';
import { selectHasError } from 'Container/App/selectors';

const mountNotification = (id: string): Notification | null => {
    const container = document.getElementById(id);

    return container && createNotification(container, NO_PATTERN_BUSINESS_LOGIC);
};

/**
 * Mount error notification
 */
export const mountErrorNotification = (): Notification | null => {
    const notification = mountNotification(ERROR_NOTIFICATION_CONTAINER_ID);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (_action, listenerApi) => {
            const hasError = selectHasError(listenerApi.getState());

            notification?.toggleContainer(!hasError);
            notification?.toggleAncestor(!hasError, `#${ERROR_NOTIFICATION_ROOT_CONTAINER}`);
        },
    });

    return notification;
};
